import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 bg-gold text-forest font-bold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg sm:text-xl text-center';
  if (href) {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };
    return <motion.a href={href} onClick={handleClick} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className={`${baseStyles} cursor-pointer ${className}`} data-id="element-28">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${className}`} {...props} data-id="element-29">
      {children}
    </motion.button>;
}